import React, { useEffect, useState, useRef } from 'react';
import ScrollToBottom from 'react-scroll-to-bottom';
import ReactQuill, { Quill } from 'react-quill';
import * as Emoji from 'quill-emoji';
import { renderMessages } from './renderMessage';
import { Mentions } from './MentionsWindow';
import File from './Assets/File.png';
import Mention from './Assets/Mention.png';
import { modules, Time } from './quill-config';
import 'react-quill/dist/quill.snow.css';
import 'quill-emoji/dist/quill-emoji.css';

Quill.register('modules/emoji', Emoji);

function Chat({ socket, username, room }) {
  const [currentMessage, setCurrentMessage] = useState('');
  const [messageList, setMessageList] = useState([]);
  const [users, setUsers] = useState([]);
  const [showMentions, setShowMentions] = useState(false);

  const MentionedUser = (user) => {
    var htmlToInsert = `<a href='notalink'>@${user}</a>`;
    var editor = document.getElementsByClassName('ql-editor');
    editor[0].innerHTML = `${currentMessage} ${htmlToInsert}`.replace(
      '<p><br></p>',
      ''
    );
  };

  console.log(currentMessage);

  const inputRef = useRef(null);
  //function to send file as binary
  const sendFile = (file) => {
    if (file) {
      const messageData = {
        room: room,
        author: username,
        type: file.type,
        time: Time,
        message: file,
        fileName: file.name,
      };
      console.log(messageData);
      socket.emit('send_message', messageData);
      setMessageList((list) => [...list, messageData]);
    }
  };
  //function to send messages
  const sendMessage = () => {
    if (currentMessage.length === 0) return;
    const messageData = {
      room: room,
      author: username,
      type: 'text',
      message: currentMessage,
      time: Time,
    };

    socket.emit('send_message', messageData);
    setMessageList((list) => [...list, messageData]);
    setCurrentMessage('');
  };
  //reading incomming messages

  useEffect(() => {
    socket.on('receive_message', (data) => {
      setMessageList((list) => [...list, data]);
    });
    return function cleanup() {
      socket.removeListener('receive_message');
    };
  }, [socket]);

  useEffect(() => {
    socket.on('users', (users) => {
      setUsers(users);
      setShowMentions(true);
    });
    return function cleanup() {
      socket.removeListener('users');
    };
  }, [socket]);

  const getUser = () => {
    socket.emit('getusers');
  };

  return (
    <div className="chat-window">
      <div className="chat-header">
        <p>ROOM</p>
        <span className="roomId">{room}</span>
      </div>

      <div className="chat-body">
        <ScrollToBottom className="message-container">
          {messageList.map((message, index) =>
            renderMessages(message, index, username)
          )}
        </ScrollToBottom>
        {showMentions ? (
          <div className="mention-window">
            {users.map((user, index) => {
              if (user.room === room) {
                return Mentions(user, MentionedUser, setShowMentions);
              }
            })}
          </div>
        ) : null}
      </div>
      <div className="bottomWrap">
        <ReactQuill
          theme="snow"
          placeholder="Type a message"
          value={currentMessage.replace('<p> </p>', '')}
          onChange={(e) => {
            setCurrentMessage(e);
          }}
          modules={modules}
          onKeyUp={(e) => {
            console.log(currentMessage);
            if (currentMessage !== '<p><br></p>') {
              if (e.key === 'Enter' && e.shiftKey) {
                return;
              }
              if (e.key === 'Enter' && !e.shiftKey) {
                sendMessage();
              }
            }
          }}
        />
        <div className="footer-footer">
          <div className="bottom-toolbar">
            <input
              ref={inputRef}
              onChange={(e) => {
                sendFile(e.target.files[0]);
              }}
              type="file"
              style={{ display: 'none' }}
            />
            <img
              src={File}
              alt="choose file"
              onClick={() => inputRef.current.click()}
            />
            <img src={Mention} alt="mention" onClick={() => getUser()} />
          </div>

          <button className="sendButton" onClick={sendMessage}>
            &#9658;
          </button>
        </div>
      </div>
    </div>
  );
}

export default Chat;
